import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconFolderWellM(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 3.2C1 2.53726 1.52233 2 2.16667 2L5.66667 2C6.311 2 6.83333 2.53726 6.83333 3.2L13.8333 3.2C14.4777 3.2 15 3.73726 15 4.4L15 12.8C15 13.1295 14.8709 13.428 14.6619 13.6448L11.5662 7.33047C11.3502 6.88984 10.6498 6.88984 10.4338 7.33047L7.16399 14H2.16667C1.52233 14 1 13.4627 1 12.8L1 3.2Z"
        fill="#97B2C4"
      />
      <path
        d="M13.5 15L11 10L8.5 15"
        stroke="#32B4FF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M11 10.5V15" stroke="#32B4FF" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
export const IconFolderWell = createIcon({
  l: IconFolderWellM,
  m: IconFolderWellM,
  s: IconFolderWellM,
  xs: IconFolderWellM,
  name: 'IconFolderWell',
})
